// geschenkemitstyle.de — Scroll-Reveal-Animation (einmal geladen, gilt für alle Sektionen)
document.addEventListener('DOMContentLoaded', function () {
  var reveals = document.querySelectorAll('.gms-reveal');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('gms-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  reveals.forEach(function (r) { io.observe(r); });
});